/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Branch_ArchivedInputs */

const en_api_error_branch_archived = /** @type {(inputs: Api_Error_Branch_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This branch is archived and can no longer be selected.`)
};

const pt_br2_api_error_branch_archived = /** @type {(inputs: Api_Error_Branch_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta filial está arquivada e não pode mais ser selecionada.`)
};

/**
* | output |
* | --- |
* | "This branch is archived and can no longer be selected." |
*
* @param {Api_Error_Branch_ArchivedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_branch_archived = /** @type {((inputs?: Api_Error_Branch_ArchivedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Branch_ArchivedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_branch_archived(inputs)
	return pt_br2_api_error_branch_archived(inputs)
});